import { FETCH_PICKUP_RATE_SUCCESS, FETCH_PICKUP_RATE_REQUEST, FETCH_PICKUP_RATE_FAILURE, FETCH_PICKUP_RATE_REST, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const pickupRateReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PICKUP_RATE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_PICKUP_RATE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_PICKUP_RATE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_PICKUP_RATE_REST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        default:
            return state;
    }
};
export default pickupRateReducer;
